import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Category, PAGE_CONTENT, PageContent, SearchResult, SubCategories } from '../../content';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent {
  public searchControl: UntypedFormControl = new UntypedFormControl();
  public searchResults$: Observable<Array<SearchResult>>;

  constructor(private readonly router: Router) {

    this.searchResults$ = this.searchControl.valueChanges.pipe(
      debounceTime(1000),
      map((str: string) => {
        return str && str.length >= 2 ? PAGE_CONTENT.reduce((acc: Array<SearchResult>, curr: Category) => {
          curr.pageContent.forEach((page: PageContent) => {
            page.categories.forEach((cat: SubCategories) => {
              if (cat.categoriesTitle.toLowerCase().indexOf(str.trim().toLowerCase()) !== -1) {
                acc.push({
                  url: curr.url,
                  subUrl: cat.categoriesUrl,
                  title: curr.title,
                  subTitle: cat.categoriesTitle
                });
              }
            });
          });
          return acc;
        }, []) : [];
      })
    );
  }

  navigateToCategory(searchResult: SearchResult) {
    this.router.navigate([searchResult.url, searchResult.subUrl]);
    this.searchControl.setValue('');
  }
}
